export const STATUS_CHANGE_LOADING = 'STATUS_CHANGE_LOADING';
export const STATUS_CHANGE_LOAD_ERROR = 'STATUS_CHANGE_LOAD_ERROR';
export const STATUS_CHANGE_GET_REPORT = 'STATUS_CHANGE_GET_REPORT';
export const STATUS_CHANGE_SET_SELECTED_SITES = 'STATUS_CHANGE_SET_SITES';
export const STATUS_CHANGE_CLEAR_ERRORS = 'STATUS_CHANGE_CLEAR_ERRORS';



// WEBPACK FOOTER //
// ./src/pages/statuschange/state/report/types.js